export default __webpack_public_path__ + "static/allency-dark-295d120a8a080e517cde3dcd1426b87d.svg";